import sanitizeHtml from 'sanitize-html'

import { arrayRemove } from './ArrayHelpers'
import { isEmpty } from './Comparisons'

export const GUIDFormat = '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$'

export function stripHtml(html: string): string {
  return sanitizeHtml(html, {
    allowedTags: [],
    allowedAttributes: {},
  })
}

export async function copyToClipboard(textToCopy: string) {
  try {
    await navigator.clipboard.writeText(textToCopy)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to copy: ', err)
  }
}

export function csvToArray(values: string): string[] {
  return parseDelimitedString(',', values)
}

function parseDelimitedString(delimiter: string, values: string): string[] {
  return values
    .split(delimiter)
    .map((value) => value.trim())
    .filter((value) => value.length > 0)
}

export function randomIdentifier(): string {
  return Math.random().toString().replace('0.', '')
}

export function capitalise(string: string): string {
  if (!string) {
    return ''
  }

  return string.charAt(0).toUpperCase() + string.slice(1)
}

// Recursively walks the provided object "o" and removes keys if the "fn" function returns true.
// The function is passed the current object and key.
export function strip(o: any, fn: Function, dontStripEmpty: boolean) {
  if (o === undefined || o === null || ![Object, Array].includes(o.constructor)) {
    return false
  }
  if (o.constructor === Array) {
    o.forEach((el) => {
      if (strip(el, fn, dontStripEmpty)) {
        arrayRemove(o, el)
      }
    })
  } else {
    Object.keys(o).forEach((k) => {
      if ((fn && fn(o, k)) || strip(o[k], fn, dontStripEmpty)) {
        delete o[k]
      }
    })
  }
  return dontStripEmpty !== true && isEmpty(o)
}

export function randomString(pref: string = '') {
  return `${pref}${Math.random().toString(36).substring(2)}`
}

export function humanReadable(text: string, caseType: 'sentence' | 'title' = 'sentence'): string {
  if (caseType == 'sentence') {
    return capitalise(text).replace(/_/g, ' ')
  } else {
    const out = text.split('_').map((word) => {
      return capitalise(word)
    })

    return out.join(' ')
  }
}
